export type CareTeamDetailsParams = {
    id: string;
};
export const careTeamDetails = ({ id = ":id" }: Partial<CareTeamDetailsParams> = {}) =>
    `/provider/people/careteam/${id}`;

